/* FR Makeover – Suchergebnisseite (sections/fr-search.liquid)
   Größe/Warenkorb + Header-Feld: assets/fr-search-ui.js (global) */
(function () {
  var root = document.querySelector('[data-fr-search]');
  if (!root) return;
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var term = root.dataset.terms;

  /* ---------- Filter: sofort anwenden, immer nur ein Popover offen ---------- */
  var mqPhone = window.matchMedia('(max-width: 749px)');
  var chipsOf = function () { return root.querySelectorAll('[data-fr-chip]'); };
  function bindChips() {
    var bar = root.querySelector('.fr-s-bar');
    chipsOf().forEach(function (d) {
      if (d.__frBound) return; d.__frBound = true;
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        chipsOf().forEach(function (o) { if (o !== d) o.open = false; });
        var pop = d.querySelector('.fr-s-pop');
        if (pop) pop.style.top = mqPhone.matches && bar ? (bar.getBoundingClientRect().bottom + 6) + 'px' : '';
      });
    });
  }
  bindChips();
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fr-chip]')) return;
    chipsOf().forEach(function (o) { o.open = false; });
  });

  /* Hautziel-/Produktart-Seite: Filter, Ziel-Chips, Sortierung und Seiten ohne Neuladen (Section Rendering API) */
  var sectionId = root.dataset.frSection;
  var ajaxBusy = false;
  function ajaxLoad(url, push) {
    if (!sectionId || ajaxBusy) return false;
    ajaxBusy = true;
    root.classList.add('is-loading');
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', sectionId);
    fetch(u.toString(), { headers: { 'Accept': 'text/html' } }).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-fr-hautziel]');
      if (!fresh) throw new Error('no section');
      var sel = ['.fr-hz-facts', '.fr-s-bar', '.fr-hz-pages'];
      sel.forEach(function (q) {
        var a = root.querySelector(q), b = fresh.querySelector(q);
        if (a && b) a.replaceWith(b); else if (a && !b) a.remove();
      });
      /* Produktblöcke (erste Produkte / weitere Produkte / leer) der Reihe nach tauschen */
      var oldBlocks = root.querySelectorAll('.fr-hz-block'), newBlocks = fresh.querySelectorAll('.fr-hz-block');
      var anchor = root.querySelector('.fr-hz-rf');
      oldBlocks.forEach(function (b) { b.remove(); });
      var wrap = anchor ? anchor.parentNode : root.querySelector('.fr-hz-wrap:last-of-type');
      if (newBlocks[0]) wrap.insertBefore(newBlocks[0], anchor || null);
      for (var i = 1; i < newBlocks.length; i++) {
        if (anchor && anchor.nextSibling) wrap.insertBefore(newBlocks[i], anchor.nextSibling); else wrap.appendChild(newBlocks[i]);
        anchor = newBlocks[i];
      }
      bindChips();
      var clean = new URL(u.toString()); clean.searchParams.delete('section_id');
      if (push) history.pushState({ fr: 1 }, '', clean.toString());
      var top = root.querySelector('#produkte');
      if (top) { var y = top.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64); window.scrollTo({ top: y, behavior: 'smooth' }); }
    }).catch(function () { location.href = url; }).finally(function () { ajaxBusy = false; root.classList.remove('is-loading'); });
    return true;
  }

  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-fr-autosubmit]')) return;
    var form = e.target.closest('[data-fr-filter-form]');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-fr-filter-form]');
    if (!form) return;
    form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    if (!sectionId) return;
    e.preventDefault();
    var action = form.getAttribute('action') || location.pathname;
    var qs = new URLSearchParams(new FormData(form)).toString();
    ajaxLoad(action + (qs ? '?' + qs : ''), true);
  });
  root.addEventListener('click', function (e) {
    if (!sectionId) return;
    var a = e.target.closest('.fr-hz-chips a, .fr-s-reset, .fr-hz-pages a, .fr-hz-empty a');
    if (!a || e.metaKey || e.ctrlKey) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || href.indexOf('/search') === 0) return;
    e.preventDefault();
    ajaxLoad(href, true);
  });
  window.addEventListener('popstate', function () { if (sectionId) ajaxLoad(location.href, false); });

  if (!term) return;

  /* ---------- Kategorien, Ratgeber, "Meintest du" aus der Vorschlags-Abfrage ---------- */
  var url = shopRoot + 'search/suggest?q=' + encodeURIComponent(term) +
    '&resources%5Btype%5D=collection,article,query&resources%5Blimit%5D=10&section_id=fr-predictive-search';

  /* Passende Kategorien: Titel-Treffer der Vorschlags-Abfrage zuerst, dann die freigegebenen
     Kollektionen der Top-Treffer (<template data-fr-cols>), sortiert nach Häufigkeit, dann spezifischer (weniger Produkte) */
  function frMergeCats(predLinks, scope) {
    var out = [], seen = {};
    var key = function (a) { return (a.getAttribute('href') || '').split('?')[0]; };
    Array.prototype.forEach.call(predLinks || [], function (a) { var k = key(a); if (k && !seen[k]) { seen[k] = 1; out.push(a); } });
    var stats = {}, order = [];
    Array.prototype.forEach.call(scope.querySelectorAll('template[data-fr-cols]'), function (t) {
      Array.prototype.forEach.call(t.content.querySelectorAll('a'), function (a) {
        var k = key(a);
        if (!k || seen[k]) return;
        if (!stats[k]) { stats[k] = { a: a, n: 0, c: Number(a.dataset.count) || 9999 }; order.push(k); }
        stats[k].n++;
      });
    });
    order.sort(function (x, y) { return (stats[y].n - stats[x].n) || (stats[x].c - stats[y].c); });
    order.forEach(function (k) { out.push(stats[k].a); });
    return out;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }).then(function (html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var cols = frMergeCats(doc.querySelectorAll('[data-fr-ps-collections] a'), root).slice(0, 4);
    var arts = Array.prototype.slice.call(doc.querySelectorAll('[data-fr-ps-articles] a'), 0, 3);
    var queries = Array.prototype.slice.call(doc.querySelectorAll('[data-fr-ps-queries] a'));

    /* Kategorien: Desktop Bildkacheln in der Seitenspalte, mobil Chip-Zeile */
    if (cols.length) {
      var tilesWrap = root.querySelector('[data-fr-cattiles]');
      var tiles = root.querySelector('[data-fr-tiles]');
      var chipRow = root.querySelector('[data-fr-catchips]');
      cols.forEach(function (a) {
        if (tiles) {
          var t = el('a', 'fr-sp-tile');
          t.href = a.getAttribute('href');
          var im = el('span', 'fr-sp-tile__img');
          if (a.dataset.img) { var img = new Image(); img.src = a.dataset.img; img.alt = ''; img.loading = 'lazy'; im.appendChild(img); }
          t.appendChild(im);
          var tx = el('span', 'fr-sp-tile__txt');
          tx.appendChild(el('span', 'fr-sp-tile__name', a.textContent));
          if (a.dataset.count && a.dataset.count !== '0') tx.appendChild(el('span', 'fr-sp-tile__count', a.dataset.count + ' Produkte'));
          t.appendChild(tx);
          tiles.appendChild(t);
        }
        if (chipRow) {
          var c = el('a', 'fr-sp-catchip', a.textContent);
          c.href = a.getAttribute('href');
          chipRow.appendChild(c);
        }
      });
      if (tilesWrap) tilesWrap.hidden = false;
      if (chipRow) { chipRow.insertBefore(el('span', 'fr-sp-catchips__label', cols.length > 1 ? 'Kategorien' : 'Kategorie'), chipRow.firstChild); chipRow.hidden = false; }
      var cc = root.querySelector('[data-fr-count-cats]');
      if (cc) { cc.textContent = cols.length + (cols.length > 1 ? ' Kategorien' : ' Kategorie'); cc.hidden = false; }
    }

    /* Ratgeber: nur ergänzen, wenn die Ergebnisse keine Artikel enthielten */
    var artBlock = root.querySelector('[data-fr-artblock]');
    var artGrid = root.querySelector('[data-fr-artgrid]');
    if (artGrid && !artGrid.children.length && arts.length) {
      arts.forEach(function (a) {
        var c = el('a', 'fr-sp-art');
        c.href = a.getAttribute('href');
        var im = el('span', 'fr-sp-art__img');
        if (a.dataset.img) { var img = new Image(); img.src = a.dataset.img; img.alt = ''; img.loading = 'lazy'; im.appendChild(img); }
        c.appendChild(im);
        c.appendChild(el('span', 'fr-sp-art__kicker', 'Skincare-Blog'));
        c.appendChild(el('span', 'fr-sp-art__title', a.textContent));
        artGrid.appendChild(c);
      });
      if (artBlock) artBlock.hidden = false;
      var ca = root.querySelector('[data-fr-count-arts]');
      if (ca) { ca.textContent = arts.length + ' Blogartikel'; ca.hidden = false; }
    }

    /* Wirkstoff-Karte: Link auf den ersten passenden Ratgeber */
    var ingLink = root.querySelector('[data-fr-ing-link]');
    var firstArt = (artGrid && artGrid.querySelector('a')) || arts[0];
    if (ingLink && firstArt) { ingLink.href = firstArt.getAttribute('href'); ingLink.hidden = false; }

    /* Leerzustand: "Meintest du …" */
    var didyou = root.querySelector('[data-fr-didyou]');
    if (didyou) {
      var alt = queries.filter(function (a) { return a.dataset.q && a.dataset.q.toLowerCase() !== term.toLowerCase(); }).slice(0, 3);
      if (alt.length) {
        alt.forEach(function (a, i) {
          var l = el('a', null, a.dataset.q);
          l.href = shopRoot + 'search?q=' + encodeURIComponent(a.dataset.q) + '&options%5Bprefix%5D=last';
          if (i) didyou.appendChild(document.createTextNode(' · '));
          didyou.appendChild(l);
        });
        didyou.hidden = false;
      }
    }
  }).catch(function () {});
})();
